import {
  getEnvFromHostname,
  RuntimeEnvironmentOptions,
} from "@growtherapy/analytics";
import * as FS from "@fullstory/browser";

export function sendFullStoryEvent(
  eventName: string,
  eventProperties: object = {},
) {
  if (
    FS.isInitialized() &&
    getEnvFromHostname({ hostname: location.hostname }) ===
      RuntimeEnvironmentOptions.production
  ) {
    FS.event(eventName, eventProperties);
  }
}
